/**
 * not to be confused with NODE_ENV — NODE_ENV is 'development' for local
 * and 'production' for production and staging environments
 */
export const DEPLOYMENT_ENV = process.env.REACT_APP_DEPLOYMENT_ENV || null

export const WP_API_URL =
  process.env.REACT_APP_WP_API_URL ||
  null

export const WP_GRAPHQL = 
process.env.REACT_APP_WP_GRAPHQL ||
  null

/**
 * client name used for making the Thrive platform `/get_auth_configuration`
 * call
 */
export const THRIVE_CLIENT_NAME =
  process.env.REACT_APP_THRIVE_CLIENT_NAME || 'staging-thrive-web-local-test'

/**
 * Amplify-related auth config variables. See:
 * https://aws-amplify.github.io/docs/js/authentication#manual-setup
 */

export const AMPLIFY_AUTH_FLOW_TYPE =
  process.env.REACT_APP_AMPLIFY_AUTH_FLOW_TYPE || 'USER_SRP_AUTH'

export const AMPLIFY_REGION =
  process.env.REACT_APP_AMPLIFY_REGION || 'us-east-1'

export const SEGMENT_SOURCE_ID = process.env.REACT_APP_SEGMENT_SOURCE_ID || null

export const OPTIMIZELY_SDK_KEY =
  process.env.REACT_APP_OPTIMIZELY_SDK_KEY || null

// set to `false` for local development unless intentionally testing Sentry
export const USE_SENTRY_IO = process.env.REACT_APP_USE_SENTRY_IO || 'false'

export const SENTRY_IO_DSN = process.env.REACT_APP_SENTRY_IO_DSN || null

// okta configuration
export const REACT_APP_OKTA_ISSUER =
  process.env.REACT_APP_OKTA_ISSUER || 'https://staging-auth.thriveglobal.com'

export const REACT_APP_PARDOT = process.env.REACT_APP_PARDOT || 'https://go.pardot.com/l/854053/2021-08-12/p1c2w'
